module.exports = "https://www.gc-qa.gnp.com.mx/9d9a1a97368a146127f030ffa240e2c7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/circle-pago-ok.svg
// module id = 1805
// module chunks = 0